<script lang="ts">
    import type {MvPdfRenderService} from 'src/features/media-viewer/services/mv-pdf-render.service';
    import {onMount, onDestroy} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';

    export let width: number;
    export let height: number;
    export let pageNumber: number;
    export let pdfRenderService: MvPdfRenderService;

    let containerElement: HTMLDivElement;
    let intersectionObserver: IntersectionObserver;

    onMount(() => {
        // Create intersection observer with rootMargin to start loading before the page is fully visible
        intersectionObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    pdfRenderService.queuePageForRender(pageNumber);

                    // Once we've queued the page, we can stop observing
                    if (exists(intersectionObserver)) {
                        intersectionObserver.unobserve(entry.target);
                    }
                }
            });
        }, {
            root: null,
            rootMargin: '100% 0px 100% 0px',
            threshold: 0
        });

        if (exists(containerElement)) {
            intersectionObserver.observe(containerElement);
        }
    });

    onDestroy(() => {
        if (exists(intersectionObserver)) {
            intersectionObserver.disconnect();
        }
    });
</script>

<div id="mv-pdf-page-{pageNumber}"
     class="mv-placeholder-pdf-page"
     bind:this={containerElement}
     style:width="{width}px"
     style:height="{height}px">

    <KpLoadingBlock size="sm"/>
</div>

<style lang="less">
    @import (reference) "src/features/media-viewer/media-viewer.variables.less";

    .mv-placeholder-pdf-page {
        width: var(--width);
        height: var(--height);
        border-radius: @border-radius-large;
        border: 1px solid var(--viewer-default-border);
        background-color: var(--viewer-bg);
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>